import { v4 as uuid } from "uuid";

// child age
export const childAges = [
  {
    title: "0 - 1 سال",
    value: 0,
    key: uuid(),
  },
  {
    title: "1 - 2 سال",
    value: 1,
    key: uuid(),
  },
  {
    title: "2 - 3 سال",
    value: 2,
    key: uuid(),
  },
  {
    title: "3 - 4 سال",
    value: 3,
    key: uuid(),
  },
  {
    title: "4 - 5 سال",
    value: 4,
    key: uuid(),
  },
  {
    title: "5 - 6 سال",
    value: 5,
    key: uuid(),
  },
  {
    title: "6 - 7 سال",
    value: 6,
    key: uuid(),
  },
  {
    title: "7 - 8 سال",
    value: 7,
    key: uuid(),
  },
  {
    title: "8 - 9 سال",
    value: 8,
    key: uuid(),
  },
  {
    title: "9 - 10 سال",
    value: 9,
    key: uuid(),
  },
  {
    title: "10 - 11 سال",
    value: 10,
    key: uuid(),
  },
  {
    title: "11 - 12 سال",
    value: 11,
    key: uuid(),
  },
];

export const hotelLocationType = {
  city: {
    value: 1,
    title: 'شهر'
  },
  hotel: {
    value: 2,
    title: 'هتل'
  }
};

export const tourSectionList = {
  package: {
    title: "تور گروهی",
    value: 1,
    id: uuid(),
  },
  trip: {
    title: "تور پرواز + هتل",
    value: 2,
    id: uuid(),
  },
}

export const hotelDestinationType = {
  externalHotel: {
    title: "هتل خارجی",
    value: 1,
    id: uuid(),
  },
  internalHotel: {
    title: "هتل داخلی",
    value: 2,
    id: uuid(),
  },
}

export const iranNationality = {
  name: "Iran",
  countryCode: "ir",
  phoneCode: "+98",
  name_fa: "ایران"
};

export const internalFlightRoutes = [
  {
    value: 1,
    title: "یک طرفه",
    key: uuid(),
  },
  {
    value: 2,
    title: "رفت و برگشت",
    key: uuid(),
  },
];

export const externalFlightRoutes = [
  {
    value: 1,
    title: "یک طرفه",
    key: uuid(),
  },
  {
    value: 2,
    title: "رفت و برگشت",
    key: uuid(),
  },
  {
    value: 3,
    title: "چند مسیره",
    key: uuid(),
  },
];

export const cabinTypeList = [
  {
    title: "اکونومی",
    value: "Economy",
    cabinTypeNumber: 3,
    key: uuid(),
  },
  {
    title: "فرست",
    value: "First",
    cabinTypeNumber: 1,
    key: uuid(),
  },
  {
    title: "بیزینس",
    value: "Business",
    cabinTypeNumber: 2,
    key: uuid(),
  },
  {
    title: "پریمیوم",
    value: "Premium",
    cabinTypeNumber: 4,
    key: uuid(),
  },
  { title: "پریمیوم اکونومی", value: "PremiumEconomy", key: uuid(), cabinTypeNumber:16},
  { title: "کامفورت", value: "Comfort", key: uuid(), cabinTypeNumber:32},
  { title: "اکونومی پلاس", value: "EconomyPlus", key: uuid(), cabinTypeNumber:64},
  { title: "پریمیوم بیزینس", value: "BusinessPremium", key: uuid(), cabinTypeNumber:128},
];

export const trainRoutes = [
  {
    value: 1,
    title: "یک طرفه",
    key: uuid(),
  },
  {
    value: 2,
    title: "رفت و برگشت",
    key: uuid(),
  },
];

export const trainLocationType = {
  station: {
    id: 1,
    value: "station",
    title: "ایستگاه",
    key: uuid(),
  },
  city: {
    id: 2,
    value: "city",
    title: "شهر",
    key: uuid(),
  },
};

export const CIPTripType = {
  international: {
    value: 1,
    title: "پرواز بین المللی",
  },
  domestic: {
    value: 2,
    title: "پرواز داخلی",
  },
}

export const CIPFlightType = {
  arrival: {
    value: 1,
    title: "پرواز ورودی به فرودگاه",
  },
  departure: {
    value: 2,
    title: "پرواز خروجی از فرودگاه",
  },
}

export const clocksList = [
  {
    label: "00:00",
    value: "00:00",
  },
  {
    label: "00:30",
    value: "00:30",
  },
  {
    label: "01:00",
    value: "01:00",
  },
  {
    label: "01:30",
    value: "01:30",
  },
  {
    label: "02:00",
    value: "02:00",
  },
  {
    label: "02:30",
    value: "02:30",
  },
  {
    label: "03:00",
    value: "03:00",
  },
  {
    label: "03:30",
    value: "03:30",
  },
  {
    label: "04:00",
    value: "04:00",
  },
  {
    label: "04:30",
    value: "04:30",
  },
  {
    label: "05:00",
    value: "05:00",
  },
  {
    label: "05:30",
    value: "05:30",
  },
  {
    label: "06:00",
    value: "06:00",
  },
  {
    label: "06:30",
    value: "06:30",
  },
  {
    label: "07:00",
    value: "07:00",
  },
  {
    label: "07:30",
    value: "07:30",
  },
  {
    label: "08:00",
    value: "08:00",
  },
  {
    label: "08:30",
    value: "08:30",
  },
  {
    label: "09:00",
    value: "09:00",
  },
  {
    label: "09:30",
    value: "09:30",
  },
  {
    label: "10:00",
    value: "10:00",
  },
  {
    label: "10:30",
    value: "10:30",
  },
  {
    label: "11:00",
    value: "11:00",
  },
  {
    label: "11:30",
    value: "11:30",
  },
  {
    label: "12:00",
    value: "12:00",
  },
  {
    label: "12:30",
    value: "12:30",
  },
  {
    label: "13:00",
    value: "13:00",
  },
  {
    label: "13:30",
    value: "13:30",
  },
  {
    label: "14:00",
    value: "14:00",
  },
  {
    label: "14:30",
    value: "14:30",
  },
  {
    label: "15:00",
    value: "15:00",
  },
  {
    label: "15:30",
    value: "15:30",
  },
  {
    label: "16:00",
    value: "16:00",
  },
  {
    label: "16:30",
    value: "16:30",
  },
  {
    label: "17:00",
    value: "17:00",
  },
  {
    label: "17:30",
    value: "17:30",
  },
  {
    label: "18:00",
    value: "18:00",
  },
  {
    label: "18:30",
    value: "18:30",
  },
  {
    label: "19:00",
    value: "19:00",
  },
  {
    label: "19:30",
    value: "19:30",
  },
  {
    label: "20:00",
    value: "20:00",
  },
  {
    label: "20:30",
    value: "20:30",
  },
  {
    label: "21:00",
    value: "21:00",
  },
  {
    label: "21:30",
    value: "21:30",
  },
  {
    label: "22:00",
    value: "22:00",
  },
  {
    label: "22:30",
    value: "22:30",
  },
  {
    label: "23:00",
    value: "23:00",
  },
  {
    label: "23:30",
    value: "23:30",
  },
];

// passenger list
export const passengerList = [
  {
    value: 1,
    title: "1 نفر",
    key: uuid(),
  },
  {
    value: 2,
    title: "2 نفر",
    key: uuid(),
  },
  {
    value: 3,
    title: "3 نفر",
    key: uuid(),
  },
  {
    value: 4,
    title: "4 نفر",
    key: uuid(),
  },
  {
    value: 5,
    title: "5 نفر",
    key: uuid(),
  },
  {
    value: 6,
    title: "6 نفر",
    key: uuid(),
  },
  {
    value: 7,
    title: "7 نفر",
    key: uuid(),
  },
  {
    value: 8,
    title: "8 نفر",
    key: uuid(),
  },
  {
    value: 9,
    title: "9 نفر",
    key: uuid(),
  },
];

export const NumbersInLetters = ["اول", "دوم", "سوم", "چهارم", "پنجم", "ششم", "هفتم", "هشتم", "نهم", "دهم"];

export const BreakPoints = {
  md : 993
}